import { Component, Fragment } from 'react';
import autoscroll from './Scroll';
import CreateTemplate from './index';
import { toast as toastr } from 'react-toastify';
import { apiHost } from 'Helpers/apiurl';
import { authHeader } from 'Helpers/index';
import CryptoJS from 'crypto-js';
import Cryptlib from 'cryptlib';
import { arrayBufferToWordArray } from 'Helpers/DecryptFile';
class OptimizedTemplate extends Component {
  shouldComponentUpdate(nextProps) {
    return (nextProps.msgId !== this.props.msgId );
  }
  render() {
    return <CreateTemplate { ...this.props } />;
  }
}

class ChatTemplate extends Component {
downloadFile = async ({ filename, mediaFileToken, encryptKey, ivString }) => {
  if (!mediaFileToken || !encryptKey || !ivString) {
    toastr.error('Missing media token, encryption key or IV');
    return;
  }

  const downloadUrl = `${ apiHost }/media/download?fileToken=${ mediaFileToken }`;

  try {
    const res = await fetch(downloadUrl, {
      headers: { ...authHeader() },
    });

    if (!res.ok) throw new Error('Failed to fetch encrypted blob');

    const encryptedBlob = await res.blob();
    if (encryptedBlob.size <= 1) throw new Error('Invalid encrypted blob');

    const buffer = await encryptedBlob.arrayBuffer();

    // convert ArrayBuffer to WordArray
    const encryptedWords = arrayBufferToWordArray(buffer);

    // Prepare key & IV
    const key = CryptoJS.enc.Utf8.parse(Cryptlib.getHashSha256(encryptKey, 32));
    const iv = CryptoJS.enc.Utf8.parse(ivString.substring(0, 16));

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: encryptedWords },
      key,
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    // Convert to Uint8Array
    const decryptedBytes = new Uint8Array(decrypted.sigBytes);
    for (let i = 0; i < decrypted.sigBytes; i++) {
      decryptedBytes[ i ] = (decrypted.words[ i >>> 2 ] >>> (24 - (i % 4) * 8)) & 0xff;
    }

    const decryptedBlob = new Blob([ decryptedBytes ]);
    
    // download
    const blobUrl = window.URL.createObjectURL(decryptedBlob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename || 'downloaded_file';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    toastr.error('Failed to download and decrypt file');
  }
};

  constructMessageTemplate = () => {
    const { chatmessages, feedbackDetails } = this.props;
    if (!chatmessages) return null;
    return chatmessages.map((msg) => {
      const { msgId, msgType } = msg;
      if (msgType !== 'auto_text'){
        return (
          <OptimizedTemplate
            message_type={ msgType }
            key={ msgId }
            { ...msg }
            downloadFile = { this.downloadFile }
            feedbackDetails= { feedbackDetails }
            msgId={ msgId }
          />
        );
      }else{
        return null
      }
    });
  };
  render() {
    const templates = this.constructMessageTemplate();
    return <Fragment>{templates || null}</Fragment>;
  }
}
export default autoscroll(ChatTemplate, { isScrolledDownThreshold: 100 });
